import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ServiceDetails from "./ServiceDetails";
import { useParams } from "react-router-dom";

const SeviceSinglePage: React.FC = () => {
  const { slug } = useParams();

  const TITLES: Record<string, string> = {
    institucional: "Institucional",
    comercial: "Comercial",
    "3d-elements": "3D Elements",
    "motion-graphics": "Motion Graphics",
    chromas: "Chromas",
    "eventos-empresariales": "Cobertura de Eventos",
    "trabajos-con-ia": "Trabajos con IA",
    "servicios": "Servicios",
  };

  const pageTitle =
    TITLES[(slug ?? "").toLowerCase().trim()] ?? "Service details";

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={pageTitle} pagesub={pageTitle} />
            <ServiceDetails />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SeviceSinglePage;

